export const LEGAL_MENTIONS_URL = "https://cifmd.org/mentions-legales/";